export const CITY_IDS = {
  newTaipeiCity: 'new_taipei_city',
  hsinchuCounty: 'hsinchu_county',
  hsinchuCity: 'hsinchu_city',
  taoyuan_Cty: 'taoyuan_city',
  keelungCity: 'keelung_city',
  taichungCity: 'taichung_city',
  chiayiCity: 'chiayi_city',
  tainanCity: 'tainan_city',
  kaohsiungCity: 'kaohsiung_city',
  hualienCounty: 'hualien_county',
  taitungCounty: 'taitung_county',
  penghuCounty: 'penghu_county',
  yilanCounty: 'yilan_county',
} as const;
